import styled from 'styled-components';

export const AddNewEstateContainer= styled.div
.attrs(() => ({
  className: 'white mt-25 ',
}))`

border-radius: 10px;
background: #FFF;
box-shadow: 0px 4px 50px 0px rgba(0, 0, 0, 0.03);
// padding:16px !important; 

`;



export const AddNewEstateContainerTitleSection= styled.div
.attrs(() => ({
  className: ' ',
}))`
border-bottom:1px solid #D9D9D9;

`;
